import { Injectable } from '@angular/core';

import { CategoryAction } from './category-action.model';
import { Category } from './category.model';
import { EventCentreHook } from './hook';
import { ItemAction } from './item-action.model';
import { Item } from './item.model';

@Injectable({ providedIn: 'root' })
export class EventCentreHookService {
    private readonly _hooks: EventCentreHook[];

    constructor() {
        this._hooks = [];
    }

    register(hook: EventCentreHook): void {
        if (!this._hooks.includes(hook)) {
            this._hooks.push(hook);
        }
    }

    unregister(hook: EventCentreHook): void {
        const index = this._hooks.indexOf(hook);
        if (index !== -1) {
            this._hooks.splice(index, 1);
        }
    }

    actionInvoked(item: Item, action: ItemAction): boolean {
        let dismiss = false;
        this._hooks.forEach((e) => {
            try {
                const ret = e.ecOnActionInvoked(item, action);
                dismiss = !dismiss && ret;
            } catch (e) {
                console.log(e);
            }
        });
        return dismiss;
    }

    itemsChanged(items: Item[]): void {
        this._hooks.forEach((e) => {
            try {
                e.ecOnItemsChanged(items);
            } catch (e) {
                console.log(e);
            }
        });
    }

    categoryActionInvoked(
        category: Category,
        action: CategoryAction,
        items: Item[],
    ): void {
        this._hooks.forEach((e) => {
            try {
                e.ecOnCategoryActionInvoked?.(category, action, items);
            } catch (e) {
                console.log(e);
            }
        });
    }
}
